<template>
  <section
    class="relative z-2 -mt-8 hidden rounded-t-[40px] bg-white pt-16 lg:block lg:pt-20"
  >
    <DefaultGrid>
      <div class="col-span-full space-y-8 text-center md:space-y-10">
        <p class="text-lg">As seen on</p>
        <div
          class="grid grid-cols-3 items-center gap-x-8 gap-y-8 md:grid-cols-6 md:gap-x-10"
        >
          <div
            v-for="n in 6"
            :key="n"
            class="flex h-10 items-center justify-center md:h-12"
          >
            <img
              :src="`/img/home/logo-${n}.png`"
              alt=""
              class="max-h-full max-w-[130px] object-contain opacity-70"
            />
          </div>
        </div>
      </div>
    </DefaultGrid>
  </section>
</template>
